<template>
  <div class="main-damage-picker-component">
    <div class="title">
      <span>Главная причина повреждения</span>
      <!--<p-button @click="getReasonsAndReset" class="p-button-sm"
        >Установить</p-button
      >
      -->
    </div>

    <table class="reasons-table">
      <thead>
        <tr>
          <th class="main-td">Установить главную причину</th>
          <th>Внести в Реестры ГЛПМ</th>
          <th>%</th>
          <th>код</th>
          <th>наименование</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(reason, reason_i) in mainDamageReasonList">
          <td class="main-td">
            <p-checkbox
              v-model="mainReason"
              multiple
              :value="reason"
              :disabled="reasonsSaving || reasonsLoading || !actLpoIsDraft"
              @input="onMainReasonChange($event)"
            />
          </td>
          <td>
            <p-checkbox
              v-model="editedReasonList"
              multiple
              :value="reason"
              :disabled="reasonsSaving || reasonsLoading || !actLpoIsDraft"
              @input="onEditedReasonChange($event)"
            />
          </td>
          <td>{{ reason.reason_pct + " %" }}</td>
          <td>{{ reason.reason_id }}</td>
          <td>{{ reason.reason }}</td>
        </tr>
      </tbody>
    </table>

    <div v-if="newListDiffers" class="values-btn-row">
      <div>
        <button @click="cancelSave">Отмена</button>
        <button @click="saveReasons">Сохранить</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import fetchData from "@/lib/fetchData";

const ROOT_API = process.env.VUE_APP_ROOT_API;
const GET_DAMAGE_REASONS_PCT =
  ROOT_API + "get_site_data/get_damage_reasons_pct.php";

export default {
  name: "Recount__mainDamagePicker",

  data: () => ({
    reasonsSaving: false,
    reasonsLoading: false,
    mainReason: [],
    editedReasonList: [],
  }),

  computed: {
    actLpoIsDraft() {
      return this.$store.getters["lpoData/actLpoIsDraft"];
    },

    newListDiffers() {
      if (
        !this.editedReasonList.length &&
        !this.selectedMainDamageReasonList.length
      ) {
        return false;
      }

      if (
        this.editedReasonList.length !==
        this.selectedMainDamageReasonList.length
      ) {
        return true;
      }

      const mainReasonId = this.mainReason[0]?.reason_id;
      const selectedMainReason = this.selectedMainDamageReasonList.find(
        (selectedReason) => {
          return selectedReason.is_main === "t";
        }
      );

      if (mainReasonId !== selectedMainReason?.reason_id) {
        return true;
      }

      // если размеры массивов равны
      for (const reason of this.editedReasonList) {
        const finded = this.selectedMainDamageReasonList.find(
          (selectedReason) => {
            return selectedReason.reason_id === reason.reason_id;
          }
        );

        if (!finded) {
          return true;
        }
      }

      return false;
    },

    ...mapState("lpoData", {
      currentLpo: (state) => state.currentLpo,
    }),

    ...mapState("selectedLpo/recount", {
      mainDamageReasonList: (state) => state.mainDamageReasonList,
      selectedMainDamageReasonList: (state) =>
        state.selectedMainDamageReasonList,
    }),
  },

  methods: {
    onEditedReasonChange(event) {
      if (this.mainReason.length === 1) {
        let hasMainReason = false;

        for (const reason of this.editedReasonList) {
          if (reason.reason_id === this.mainReason[0].reason_id) {
            hasMainReason = true;
          }
        }

        if (!hasMainReason) {
          this.mainReason.pop();
        }
      }
    },

    onMainReasonChange(event) {
      if (event.length === 2) {
        this.mainReason.shift();
      }

      if (this.mainReason.length === 1) {
        const finded = this.editedReasonList.find((reason) => {
          return this.mainReason[0].reason_id === reason.reason_id;
        });

        if (!finded) {
          this.editedReasonList.push(this.mainReason[0]);
        }
      }
    },

    saveReasons() {
      const payload = {
        savingReasonList: this.editedReasonList,
        mainReasonId: this.mainReason[0]?.reason_id,
      };

      this.reasonsSaving = true;

      this.saveMainDamageReasons(payload)
        .then((res) => {
          return this.getReasons();
        })
        .then((res) => {
          this.resetValues();
        })
        .finally(() => {
          this.reasonsSaving = false;
        });
    },

    cancelSave() {
      this.resetValues();
    },

    resetValues() {
      const result = [];
      this.mainReason = [];
      if(this.selectedMainDamageReasonList.length > 0) {
          for (const selectedReason of this.selectedMainDamageReasonList) {
            const finded = this.mainDamageReasonList.find((reason) => reason.reason_id === selectedReason.reason_id);
            
            if (finded) {
              if (selectedReason.is_main === "t") {
                this.mainReason = [finded];
              }
              result.push(finded);
            } 
          }
          this.editedReasonList = result;
        } else {
          this.editedReasonList = [...this.mainDamageReasonList]
        }
    },

    getReasons() {
      this.reasonsLoading = true;

      return this.getMainDamageReasonList()
        .then((res) => {
          return this.getSelectedMainDamageReasonList();
        })
        .finally(() => {
          this.reasonsLoading = false;
        });
    },

    getReasonsAndReset() {
      this.getReasons().then((res) => {
        this.resetValues();
      });
    },

    ...mapActions("selectedLpo/recount", [
      "getMainDamageReasonList",
      "getSelectedMainDamageReasonList",
      "saveMainDamageReasons",
    ]),
  },

  created() {
    console.log('created')
    this.getReasons().then((res) => {
      this.resetValues();
    });
  },
};
</script>

<style src="@/style/button.css"></style>

<style scoped>
.p-checkbox >>> .p-hidden-accessible {
  display: none;
}
</style>

<style scoped>
.main-td {
  padding-right: 1rem;
}

.main-damage-picker-component {
  margin-top: 50px;
}

.title {
  font-size: 1rem;
  font-weight: bold;
  font-style: italic;
  margin-bottom: 10px;
  display: flex;
  gap: 1rem;
  align-items: center;
}

.reasons-table {
  /*width: 100%;*/
}

.reasons-table th {
  text-align: center;
  vertical-align: middle;
}
.reasons-table th:last-child {
  padding-left: 1rem;
  text-align: left;
}

.reasons-table tr:hover td {
  background-color: #d8ecf3;
}

.reasons-table tr td {
  /*color: orange;*/
  padding: 0.2rem 1rem;
  font-size: 1rem;
  font-weight: bold;
}

.reasons-table tr td:not(:last-child) {
  text-align: center;
}

.select-value-block {
  margin-top: 34px;
}

.select-title {
  font-weight: bold;
  display: inline-block;
  margin-bottom: 6px;
}

.pest-input-block {
  margin-top: 20px;
}
</style>
